// components/industry-templates/AviationEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Plane, Cloud, MapPin, Award } from 'lucide-react';

export const AviationEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Aircraft Showcase */}
      {industryData?.aircraft_showcase && (
        <Card className="border-0 bg-gradient-to-br from-sky-500/20 to-blue-500/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <Plane className="w-8 h-8" style={{ color: theme.primary }} />
              Aircraft Showcase
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4">
              {industryData.aircraft_showcase.map((aircraft: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl border-2" style={{ borderColor: theme.primary }}>
                  <h3 className="text-xl font-bold text-white mb-2">{aircraft.model}</h3>
                  <p className="text-slate-300 mb-3">{aircraft.manufacturer}</p>
                  <div className="grid grid-cols-2 gap-2">
                    <div className="bg-white/5 rounded p-2 text-center">
                      <p className="text-xs text-slate-400">Capacity</p>
                      <p className="font-bold text-white">{aircraft.capacity}</p>
                    </div>
                    <div className="bg-white/5 rounded p-2 text-center">
                      <p className="text-xs text-slate-400">Range</p>
                      <p className="font-bold text-white">{aircraft.range}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Aviation Tech */}
      {industryData?.aviation_tech && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white">Aviation Technology</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-3 gap-3">
              {industryData.aviation_tech.map((tech: string, idx: number) => (
                <div key={idx} className="p-3 bg-white/5 rounded-lg text-center">
                  <div className="text-2xl mb-2">✈️</div>
                  <p className="text-white font-medium text-sm">{tech}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
